<template>
  <div class="common-paragraph" :class="{ right: $slots.right }">
    <div>
      <div>
        <img :src="ImageGroup" alt="" />
        <h3>{{ title }}</h3>
      </div>
      <div v-if="$slots.right">
        <slot name="right" />
      </div>
    </div>
    <slot />
  </div>
</template>

<script setup lang="ts">
import ImageGroup from '@/assets/images/group.png'
withDefaults(
  defineProps<{
    title?: string
  }>(),
  {
    title: 'Titre'
  }
)
</script>

<style scoped lang="scss">
.common-paragraph {
  height: auto;
  background-color: white;
}

.common-paragraph > div > div {
  margin-bottom: 20px;
  display: flex;
  flex-direction: row;
  gap: 10px;
}

.common-paragraph > div > div > img {
  width: 23.135px;
  height: 24px;
}

.common-paragraph.right > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
